module.exports = __webpack_public_path__ + "img/empty_campaign.47981328.png";